
import ACTS from '../constants'

const defaultStatus = {
    title: '자금관리'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.MANAGE_SUMMARY:
        return{
            ...state,
            items : action.payload.item
        }
        case ACTS.MANAGE_ILBO:
        return{
            ...state,
            items : action.payload.item
        }        
        case ACTS.MANAGE_INOUT:
        return{
            ...state,
            items : action.payload.item
        }
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/manage.js